import PatoloCareDocument from './PatoloCareDocument';

export default PatoloCareDocument;
